class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleOnFilterNavigationClick =
      this.handleOnFilterNavigationClick.bind(this);
    this.handleOnFilterElementClick =
      this.handleOnFilterElementClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    this.setEventListeners();

    facetFiltersGlobal.push(this);
  }

  setEventListeners() {
    const allFilterElements = Array.from(this.querySelectorAll("details"));

    if (allFilterElements) {
      //       const colors = allFilterElements.find(r => r.querySelector("summary span").textContent.toLowerCase().trim() === "color");

      allFilterElements.forEach((el) => {
        if (el.dataset?.index && !el.dataset?.index?.includes("mobile")) {
          el.firstElementChild.addEventListener("click", (e) =>
            this.handleOnFilterElementClick(e, allFilterElements)
          );

          const sectionToggler = el.querySelector(".facets__section-toggler");
          if (!sectionToggler) return;

          sectionToggler.querySelectorAll("button").forEach((button) => {
            button.addEventListener("click", (e) =>
              this.handleOnFilterNavigationClick(e, allFilterElements)
            );
          });
        }
      });
    }

    let mobileFacetsWrapper = document.querySelector(".mobile-facets__open-wrapper.focus-offset");
    if (mobileFacetsWrapper) {
      mobileFacetsWrapper.addEventListener("click", this.handleOnMobileFilterNavigationClick);
    }
  }

  // on page change
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  // on data update
  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  // on data update
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    window.dispatchEvent(
      new CustomEvent("facet:search-params-changed", {
        detail: { searchParams },
      })
    );
  }

  // on data update
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        handleProductQuickView();
      });
  }

  // on data update
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    handleProductQuickView();
  }

  // on data update
  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  // on data update
  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const parsedProductCount = parsedHTML.getElementById("ProductCount");
    if (!parsedProductCount) return;

    const count = parsedProductCount.innerHTML;
    const countText = parsedProductCount.textContent
      ? parsedProductCount.textContent.trim()
      : "";

    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    if (container) {
      container.innerHTML = count;
      container.classList.remove("loading");
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }

    document.querySelectorAll("[data-products-count]").forEach((node) => {
      node.textContent = countText;
    });
  }

  // on data update
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    // const matchesIndex = (element) => {
    //   const jsFilter = event ? event.target.closest(".js-filter") : undefined;
    //   console.log(jsFilter, 'matchesIndex');
    //   return jsFilter
    //     ? element.dataset.index === jsFilter.dataset.index
    //     : false;
    // };
    // const facetsToRender = Array.from(facetDetailsElements).filter(
    //   (element) => !matchesIndex(element)
    // );
    // const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetDetailsElements.forEach((element) => {
      const el = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      el.innerHTML = element.innerHTML;

      // console.log(element.dataset.index, 'el');

      // if (!element.className.includes("mobile")) {
      //   const elSummary = el.querySelector("summary");
      //   const elementSummary = element.querySelector("summary");

      //   elSummary.nextElementSibling.innerHTML =
      //     elementSummary.nextElementSibling.innerHTML;
      // } else {
        
      // }
    });

    let mobileFacetsWrapper = document.querySelector(".mobile-facets__open-wrapper.focus-offset");
    if (mobileFacetsWrapper) {
      mobileFacetsWrapper.addEventListener("click", this.handleOnMobileFilterNavigationClick);
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // if (countsToRender)
    //   FacetFiltersForm.renderCounts(
    //     countsToRender,
    //     event.target.closest(".js-filter")
    //   );

    // facetFiltersGlobal.forEach((g) => {
    //   g.setEventListeners();
    // });

    const facetsList = document.querySelector("facets-list");
    if (facetsList) {
      // facetsList.removeEventListeners();
      facetsList.setEventListeners();
    }
  }

  // on data update
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  // on data update
  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    let FacetFiltersFormMobile = document.getElementById("FacetFiltersFormMobile");
    if (FacetFiltersFormMobile) {
      FacetFiltersFormMobile.closest("menu-drawer").bindEvents();
    }
  }

  // on data update
  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  // on data update
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      String(
        window.location.pathname + (searchParams && "?".concat(searchParams))
      )
    );
  }

  // on data update
  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  // on filter click (inside drawer)
  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest("form");
    if (!form) return;

    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    const desktopSortInput = form.querySelector("#SortBy");
    const mobileSortInput = form.querySelector(
      '.facets__mobile_sort_option input[name="sort_by"]:checked'
    );
    const isMobileViewport = window.matchMedia("(max-width: 749px)").matches;
    const sortValue = isMobileViewport
      ? mobileSortInput?.value || desktopSortInput?.value || ""
      : desktopSortInput?.value || mobileSortInput?.value || "";

    if (sortValue) {
      searchParams.set("sort_by", sortValue);
    } else {
      searchParams.delete("sort_by");
    }

    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  // on reset click (inside drawer)
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(
      new URL(event.currentTarget.href).searchParams.toString()
    );
  }

  // filter navigation buttons inside drawer
  handleOnFilterNavigationClick(e, allFilterElements) {
    if (e) e.preventDefault();

    const target = e.currentTarget;
    const dataTarget = target.dataset.target;
    const currentParent = target.parentElement.parentElement.parentElement;
    let currentIndex = Number(currentParent.dataset.index);

    let parentClassName;
    let currentClassName;

    if (dataTarget === "filter-right-navigation") {
      if (currentIndex < allFilterElements.length) currentIndex += 1;
      else currentIndex = 1;
      parentClassName = "facets__slide-from-right";
      currentClassName = "facets__close-from-right";
    } else if (dataTarget === "filter-left-navigation") {
      if (currentIndex > 1) currentIndex -= 1;
      else currentIndex = allFilterElements.length;
      parentClassName = "facets__slide-from-left";
      currentClassName = "facets__close-from-left";
    }

    let parentToDisplay = this.findFilterElement(
      allFilterElements,
      (current) => currentIndex === Number(current.dataset.index)
    );
    if (!parentToDisplay) return;

    const currentParentDisplayPanel =
      currentParent.querySelector(".facets__display");
    const parentToDisplayDisplayPanel =
      parentToDisplay.querySelector(".facets__display");

    currentParentDisplayPanel.classList.add(currentClassName);
    setTimeout(() => {
      currentParentDisplayPanel.classList.remove(currentClassName);
      currentParent.removeAttribute("open");
    }, 200);

    parentToDisplay.setAttribute("open", true);
    parentToDisplayDisplayPanel.classList.add(parentClassName);
    setTimeout(() => {
      parentToDisplayDisplayPanel.classList.remove(parentClassName);
    }, 200);
  }

  handleOnMobileFilterNavigationClick() {
    let parent = document.getElementById("main-collection-filters");
    if (!parent)
      parent = document.getElementById("search-main-collection-filters");
    if (!parent) return;
    const isOpen = parent
      .querySelector("menu-drawer")
      .firstElementChild.hasAttribute("open");

    parent.style.zIndex = isOpen ? 1 : 10;
  }

  handleOnFilterElementClick(e, allFilterElements) {
    let facetsOverlay = document.getElementById("facets-overlay");
    let parent = document.getElementById("main-collection-filters");
    if (!parent)
      parent = document.getElementById("search-main-collection-filters");
    if (!parent) return;

    if (!facetsOverlay) {
      parent.style.zIndex = 10;
      facetsOverlay = document.createElement("div");
      facetsOverlay.id = "facets-overlay";
      facetsOverlay.style.cssText =
        "position: fixed; top: 0; left: 0; z-index: 3; background: #14141477; height: 100vh; width: 100vw; display: block;";
      facetsOverlay.onclick = () => {
        facetsOverlay.remove();
        facetsOverlay = undefined;
        parent.style.zIndex = 3;
        this.findFilterElement(allFilterElements, (current) =>
          current.hasAttribute("open")
        )?.removeAttribute("open");
      };
    }

    const displayPanel = e.currentTarget.nextElementSibling;
    displayPanel.classList.add("facets__slide-from-left");
    setTimeout(
      () => displayPanel.classList.remove("facets__slide-from-left"),
      200
    );

    document.querySelector(".facets-container").prepend(facetsOverlay);
  }

  findFilterElement = (allFilterElements, condition) => {
    let value = null;

    for (let i = 0; i < allFilterElements.length; i++) {
      const filterElement = allFilterElements[i];

      if (condition(filterElement)) {
        value = filterElement;
        break;
      }
    }

    return value;
  };
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.numberInputs = Array.from(this.querySelectorAll(".field__input"));
    this.minInput = this.numberInputs[0];
    this.maxInput = this.numberInputs[1];
    this.currencySymbol = this.dataset.currencySymbol || "";
    this.sliderMinInput = this.querySelector("[data-price-slider-min]");
    this.sliderMaxInput = this.querySelector("[data-price-slider-max]");
    this.sliderActiveTrack = this.querySelector("[data-price-slider-active]");
    this.sliderMinValueLabel = this.querySelector('[data-price-slider-value="min"]');
    this.sliderMaxValueLabel = this.querySelector('[data-price-slider-value="max"]');

    this.numberInputs.forEach((element) => {
      element.addEventListener("change", this.onNumberInputChange.bind(this));
      element.addEventListener("input", this.onNumberInputChange.bind(this));
    });

    if (this.sliderMinInput && this.sliderMaxInput) {
      this.sliderMinInput.addEventListener("input", this.onSliderInput.bind(this));
      this.sliderMaxInput.addEventListener("input", this.onSliderInput.bind(this));
    }

    this.initializeSliderBounds();
    this.setMinAndMaxValues();
    this.syncSliderWithInputs();
    this.updateSliderTrack();
    this.updateValueLabels();
  }

  initializeSliderBounds() {
    if (
      !this.minInput ||
      !this.maxInput ||
      !this.sliderMinInput ||
      !this.sliderMaxInput
    ) {
      return;
    }

    const minLimit = this.toNumber(this.minInput.getAttribute("min"), 0);
    const fallbackMaxFromSlider = this.toNumber(
      this.sliderMaxInput.getAttribute("max"),
      minLimit
    );
    let maxLimit = this.toNumber(this.maxInput.getAttribute("max"), fallbackMaxFromSlider);
    if (maxLimit < minLimit) maxLimit = minLimit;

    this.sliderMinInput.setAttribute("min", String(minLimit));
    this.sliderMinInput.setAttribute("max", String(maxLimit));
    this.sliderMaxInput.setAttribute("min", String(minLimit));
    this.sliderMaxInput.setAttribute("max", String(maxLimit));

    const initialMin =
      this.minInput.value !== ""
        ? this.toNumber(this.minInput.value, minLimit)
        : minLimit;
    const initialMax =
      this.maxInput.value !== ""
        ? this.toNumber(this.maxInput.value, maxLimit)
        : maxLimit;

    const clampedMin = Math.max(minLimit, Math.min(initialMin, maxLimit));
    const clampedMax = Math.max(clampedMin, Math.min(initialMax, maxLimit));

    this.sliderMinInput.value = String(clampedMin);
    this.sliderMaxInput.value = String(clampedMax);
  }

  onNumberInputChange(event) {
    if (!this.minInput || !this.maxInput) return;
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.syncSliderWithInputs();
    this.updateSliderTrack();
    this.updateValueLabels();
  }

  onSliderInput(event) {
    if (
      !this.minInput ||
      !this.maxInput ||
      !this.sliderMinInput ||
      !this.sliderMaxInput
    ) {
      return;
    }

    let minValue = this.toNumber(
      this.sliderMinInput.value,
      this.toNumber(this.sliderMinInput.min, 0)
    );
    let maxValue = this.toNumber(
      this.sliderMaxInput.value,
      this.toNumber(this.sliderMaxInput.max, minValue)
    );

    if (event.currentTarget === this.sliderMinInput && minValue > maxValue) {
      maxValue = minValue;
      this.sliderMaxInput.value = String(maxValue);
    }

    if (event.currentTarget === this.sliderMaxInput && maxValue < minValue) {
      minValue = maxValue;
      this.sliderMinInput.value = String(minValue);
    }

    this.minInput.value = this.formatNumberValue(minValue);
    this.maxInput.value = this.formatNumberValue(maxValue);
    this.setMinAndMaxValues();
    this.updateSliderTrack();
    this.updateValueLabels();
  }

  setMinAndMaxValues() {
    if (!this.minInput || !this.maxInput) return;
    if (this.maxInput.value) this.minInput.setAttribute("max", this.maxInput.value);
    if (this.minInput.value) this.maxInput.setAttribute("min", this.minInput.value);
    if (this.minInput.value === "") this.maxInput.setAttribute("min", 0);
    if (this.maxInput.value === "") {
      this.minInput.setAttribute("max", this.maxInput.getAttribute("max"));
    }
  }

  syncSliderWithInputs() {
    if (!this.sliderMinInput || !this.sliderMaxInput) return;

    const minLimit = this.toNumber(this.sliderMinInput.min, 0);
    const maxLimit = this.toNumber(this.sliderMaxInput.max, minLimit);

    let minValue =
      this.minInput && this.minInput.value !== ""
        ? this.toNumber(this.minInput.value, minLimit)
        : minLimit;
    let maxValue =
      this.maxInput && this.maxInput.value !== ""
        ? this.toNumber(this.maxInput.value, maxLimit)
        : maxLimit;

    minValue = Math.max(minLimit, Math.min(minValue, maxLimit));
    maxValue = Math.max(minValue, Math.min(maxValue, maxLimit));

    this.sliderMinInput.value = String(minValue);
    this.sliderMaxInput.value = String(maxValue);
  }

  updateSliderTrack() {
    if (!this.sliderActiveTrack || !this.sliderMinInput || !this.sliderMaxInput) return;

    const minLimit = this.toNumber(this.sliderMinInput.min, 0);
    const maxLimit = this.toNumber(this.sliderMaxInput.max, minLimit);
    const range = Math.max(maxLimit - minLimit, 1);
    const minValue = this.toNumber(this.sliderMinInput.value, minLimit);
    const maxValue = this.toNumber(this.sliderMaxInput.value, maxLimit);

    const left = ((minValue - minLimit) / range) * 100;
    const right = ((maxValue - minLimit) / range) * 100;
    const width = Math.max(0, right - left);

    this.sliderActiveTrack.style.left = `${left}%`;
    this.sliderActiveTrack.style.width = `${width}%`;
  }

  updateValueLabels() {
    if (!this.sliderMinValueLabel || !this.sliderMaxValueLabel) return;

    const minValue = this.sliderMinInput
      ? this.toNumber(this.sliderMinInput.value, 0)
      : this.toNumber(this.minInput?.value, 0);
    const maxValue = this.sliderMaxInput
      ? this.toNumber(this.sliderMaxInput.value, minValue)
      : this.toNumber(this.maxInput?.value, minValue);

    this.sliderMinValueLabel.textContent = this.formatDisplayValue(minValue);
    this.sliderMaxValueLabel.textContent = this.formatDisplayValue(maxValue);
  }

  adjustToValidValues(input) {
    if (!input || input.value === "") return;
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (!Number.isFinite(value)) return;
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  toNumber(value, fallback) {
    if (value === null || value === undefined) return fallback;
    if (typeof value === "number") {
      return Number.isFinite(value) ? value : fallback;
    }

    let normalized = String(value).trim();
    if (!normalized) return fallback;

    normalized = normalized.replace(/\u00A0/g, "").replace(/\s+/g, "");
    if (normalized.includes(",") && normalized.includes(".")) {
      normalized = normalized.replace(/,/g, "");
    } else if (normalized.includes(",") && !normalized.includes(".")) {
      normalized = normalized.replace(/,/g, ".");
    }
    normalized = normalized.replace(/[^0-9.-]/g, "");

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  formatNumberValue(value) {
    if (!Number.isFinite(value)) return "";
    const rounded = Math.round(value * 100) / 100;
    return String(rounded);
  }

  formatDisplayValue(value) {
    if (!Number.isFinite(value)) return "";
    const hasDecimals = Math.abs(value - Math.round(value)) > 0.001;
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    });
    return this.currencySymbol ? `${this.currencySymbol}${formatted}` : formatted;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}
customElements.define("facet-remove", FacetRemove);

class FacetRemoveV2 extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form = document.querySelector("#facet-filters-form");
      form.onActiveFilterClick(event);
      CloseFacetsDrawer();
    });
  }
}

customElements.define("facet-remove-v2", FacetRemoveV2);

class FacetsList extends HTMLElement {
  constructor() {
    super();
    this.lists = this.querySelectorAll(".facets__lists_item");
    this.setEventListeners();
  }

  setEventListeners() {
    this.lists.forEach((list) => {
      list.querySelector("h4").addEventListener("click", (event) => {
        if (list.classList.contains("active")) {
          list.classList.remove("active");
        } else {
          this.closeAllItems();
          list.classList.add("active");
        }
      });
    });
  }

  removeEventListeners() {
    this.lists.forEach((list) => {
      list.querySelector("h4").removeEventListener("click", (event) => {
        if (list.classList.contains("active")) {
          list.classList.remove("active");
        } else {
          this.closeAllItems();
          list.classList.add("active");
        }
      });
    });
  }

  openItem(label) {
    this.lists.forEach((list) => {
      if (list.dataset.label.toLowerCase() === label.toLowerCase()) {
        this.closeAllItems();
        if (!list.classList.contains("active")) {
          list.classList.add("active");
        }
      }
    });
  }

  closeAllItems() {
    this.lists.forEach((list) => {
      if (list.classList.contains("active")) {
        list.classList.remove("active");
      }
    });
  }
}
customElements.define("facets-list", FacetsList);

class FacetsDrawerV2 extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("click", this.outSideClick.bind(this));
    this.facetsWrapperDesktopV2 = document.querySelector("#FacetsWrapperDesktopV2");
    this.facetsWrapperContainer = document.querySelector(".facets-container--v2");
    this.toggleBtn = document.querySelector('#collection-filtter--btn');
    this.closeDrawerBtn = this.querySelector("#facets_drawer_close");
    this.showProductsBtn = this.querySelector("[data-show-products]");
    this.mobileTabButtons = Array.from(
      this.querySelectorAll("[data-facets-tab-button]")
    );
    this.mobileTabPanels = Array.from(this.querySelectorAll("[data-facets-tab-panel]"));
    this.activeMobileTab = "filters";

    if (this.facetsWrapperDesktopV2) {
      this.labelItems = this.facetsWrapperDesktopV2.querySelectorAll(".facets__title");
      this.labelItems.forEach((item) => {
        item.addEventListener("click", (event) => {
          this.openFacetsDrawer();
          let currentLabel = item.getAttribute("data-label");
          const facetsList = document.querySelector("facets-list");
          if (facetsList) {
            facetsList.openItem(currentLabel);
          }
        });
      });
    }

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.openFacetsDrawer.bind(this));
    }
    if (this.closeDrawerBtn) {
      this.closeDrawerBtn.addEventListener("click", this.closeFacetsDrawer.bind(this));
    }
    if (this.showProductsBtn) {
      this.showProductsBtn.addEventListener("click", this.closeFacetsDrawer.bind(this));
    }
    if (this.mobileTabButtons.length) {
      this.mobileTabButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.setMobileTab(button.dataset.facetsTabButton || "filters");
        });
      });
      this.setMobileTab(this.activeMobileTab);
    }
    document.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  setMobileTab(tabKey) {
    if (!this.mobileTabButtons.length || !this.mobileTabPanels.length) return;

    const requestedTab = tabKey || "filters";
    const hasRequestedPanel = this.mobileTabPanels.some(
      (panel) => panel.dataset.facetsTabPanel === requestedTab
    );
    const nextTab = hasRequestedPanel ? requestedTab : "filters";
    this.activeMobileTab = nextTab;

    this.mobileTabButtons.forEach((button) => {
      const isActive = button.dataset.facetsTabButton === nextTab;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
      if (isActive) {
        button.removeAttribute("tabindex");
      } else {
        button.setAttribute("tabindex", "-1");
      }
    });

    this.mobileTabPanels.forEach((panel) => {
      const isActive = panel.dataset.facetsTabPanel === nextTab;
      panel.classList.toggle("is-active", isActive);
      if (isActive) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "hidden");
      }
    });
  }

  lockPageScroll() {
    if (this.isPageScrollLocked) return;
    const scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.facetsV2ScrollY = String(scrollY);
    document.documentElement.classList.add("facets-v2-open");
    document.body.classList.add("facets-v2-open");
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    this.isPageScrollLocked = true;
  }

  unlockPageScroll() {
    if (!this.isPageScrollLocked) {
      document.documentElement.classList.remove("facets-v2-open");
      document.body.classList.remove("facets-v2-open");
      return;
    }

    const storedScrollY = Number.parseInt(
      document.body.dataset.facetsV2ScrollY || "0",
      10
    );
    document.documentElement.classList.remove("facets-v2-open");
    document.body.classList.remove("facets-v2-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    delete document.body.dataset.facetsV2ScrollY;
    if (Number.isFinite(storedScrollY)) {
      window.scrollTo(0, storedScrollY);
    }
    this.isPageScrollLocked = false;
  }

  outSideClick(event) {
    if (!this.facetsWrapperContainer) return;
    let element = event.target;
    if (
      element &&
      element.closest &&
      (element.closest("[data-mobile-nav-filter]") ||
        element.closest("[data-mobile-nav-sort]"))
    ) {
      return;
    }
    if (
      this.toggleBtn &&
      this.toggleBtn.contains(element) === false && 
      this.facetsWrapperContainer.classList.contains("open") === true &&
      this.facetsWrapperDesktopV2 &&
      this.facetsWrapperDesktopV2.contains(element) === false &&
      this.contains(element) === false
    ) {
      this.closeFacetsDrawer();
    }
  }

  onKeyUp(event) {
    if (!this.facetsWrapperContainer) return;
    if (event.code.toUpperCase() !== "ESCAPE") return;
    if (this.facetsWrapperContainer.classList.contains("open") === true) {
      this.closeFacetsDrawer();
    }
  }

  openFacetsDrawer() {
    if (this.facetsWrapperContainer) {
      if (this.facetsWrapperContainer.querySelector("#facets-overlay")) return;
      let html = `<div id="facets-overlay" style="position: fixed; top: 0px; left: 0px; z-index: 10; background: rgba(20, 20, 20, 0.467); height: 100vh; width: 100vw; display: block;"></div>`;
      this.facetsWrapperContainer.insertAdjacentHTML('afterbegin', html);
      this.facetsWrapperContainer.classList.add("open");
      this.setMobileTab("filters");
      this.lockPageScroll();
    }
  }

  closeFacetsDrawer(event) {
    if (!this.facetsWrapperContainer) return;
    let html = this.facetsWrapperContainer.querySelector("#facets-overlay");
    if (html) html.remove();
    this.facetsWrapperContainer.classList.remove("open");
    this.unlockPageScroll();
  }
}
customElements.define("facets-drawer-v2", FacetsDrawerV2);
